<div class="space-y-6">
  <app-page-header
    [backTo]="['/options', item()?.id ?? '']"
    backLabel="Retour à la fiche"
    title="Modifier l'équipement"
    subtitle="Les champs marqués d'un astérisque sont obligatoires."
  />

  @if (loadError() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="loadError()"
      loadingMessage="Chargement…"
      (retry)="fetch()"
    />
  } @else if (item(); as o) {
    <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
      <app-option-form
        mode="edit"
        [initial]="o"
        [submitting]="submitting()"
        [serverError]="serverError()"
        (save)="onSave($event)"
        (cancel)="onCancel()"
      />
    </section>
  }
</div>
